import baseColors from './colors';
import darkColorOverrides from './darkColorOverrides';
import semanticTokens from './semanticTokens';
import { DEFAULT_THEME_MODE, THEME_MODES } from './constants';

const resolveThemeMode = themeMode => {
  if (Object.values(THEME_MODES).includes(themeMode)) {
    return themeMode;
  }

  return DEFAULT_THEME_MODE;
};

/**
 * Cria o objeto de tema a partir do modo selecionado.
 *
 * Em estilos com styled-components:
 * - Cores primitivas: theme.colors.primary500
 * - Cores semanticas: theme.colors.semantic.text.primary
 *
 * Prefira sempre tokens semanticos para texto, superficie, borda e status.
 * Use cores primitivas apenas para casos de branding ou necessidades pontuais.
 *
 * @param {'light' | 'dark'} themeMode
 * @returns {{ mode: string, isDark: boolean, colors: object }}
 */
const createTheme = themeMode => {
  const mode = resolveThemeMode(themeMode);
  const isDark = mode === THEME_MODES.dark;
  const semantic = semanticTokens[mode] || semanticTokens[DEFAULT_THEME_MODE];
  const primitiveColors = isDark
    ? {
        ...baseColors,
        ...darkColorOverrides,
      }
    : baseColors;

  return {
    mode,
    isDark,
    colors: {
      ...primitiveColors,
      semantic: {
        ...semantic,
      },
    },
  };
};

export default createTheme;
